<template>
  <headerComponent :isShowInfo="false">
    <template slot="mainContent">
      <div class="main-left"></div>
      <div class="main-middle">
        <div class="middle-content">
          <div class="login-box">
            <el-radio-group v-model="role">
              <el-radio-button label="ERP商户登录"></el-radio-button>
              <el-radio-button label="管理员登录"></el-radio-button>
            </el-radio-group>
            <div class="text_box" v-if="role === 'ERP商户登录'">
              <span>商户请从ERP系统登入</span><br />
              <span>帮助&nbsp;>&nbsp;服务市场</span>
            </div>
            <div class="img_box" v-else>
              <img
                src="../assets/bwx_login_white.png"
                alt="企业微信登录"
                @click="jumpToIndex"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="main-right"></div>
    </template>
  </headerComponent>
</template>
<script>
import { getLogin } from "@/api/login.js";
import headerComponent from "@/components/header.vue";
export default {
  components: {
    headerComponent,
  },
  data() {
    return {
      role: "ERP商户登录",
    };
  },
  methods: {
    async jumpToIndex() {
      const data = await getLogin();
      window.open(data.data, "_self");
    },
  },
};
</script>
<style lang="scss" scoped>
.system_content::v-deep {
  background-image: linear-gradient(to bottom right, #5cb3cc, #f6ad8f);
  .login-box {
    position: absolute;
    width: 25vw;
    height: 30vh;
    box-sizing: border-box;
    padding: 40px 0;
    top: 50%;
    left: 50%;
    border-radius: 10px;
    background: white;
    transform: translate(-50%, -50%);
    text-align: center;
    .el-radio-group {
      width: 80%;
      height: 40px;
      margin-bottom: 50px;
      .el-radio-button:nth-child(1) .el-radio-button__inner {
        border-radius: 20px 0 0 20px;
      }
      .el-radio-button:nth-child(2) .el-radio-button__inner {
        border-radius: 0 20px 20px 0;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #5cb3cc;
        border-color: #5cb3cc;
        box-shadow: -0.005rem 0 0 0 #5cb3cc;
      }
      
    }
    .img_box {
      position: relative;
      width: 45%;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      > img {
        width: 100%;
        object-fit: fill;
      }
    }
    > .text_box {
      position: relative;
      width: 50%;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      >span:first-child{
        font-size: 15px;
      }
      > span:last-child {
        display: block;
        margin-top: 10px;
        font-size: 12px;
        color: rgb(170, 169, 169);
      }
    }
  }
}
</style>
